<section in:AnimIN out:AnimOUT>
    {#if $join.code === "000000"}

        <div in:AnimIN out:AnimOUT>
            ...
        </div>

    {:else}
        
        {#if $join.state === "PREPARING"}
            <div in:AnimIN out:AnimOUT>
                Gaidām spēles sākumu...
            </div>
        {/if}
        
        {#if ["QUESTIONING", "QUESTIONING_PICKED"].includes($join.state)}
            <div in:AnimIN out:AnimOUT class="all-cards">
                {#each $cards as card}
                    <Card 
                        on:click={() => pickCard(card.id)}
                        picked={picked && card.id === picked.id}
                        pickedForDisposal={$disposableCards && $disposableCards.includes(card.id)}
                        disposalMode={!!$disposableCards}
                        {card}
                        players={$host.players}
                    />
                {/each}
            </div>

            {#if $disposableCards}
                <div class="disposal-panel">
                    <ButtonCancel on:click={switchModes} />

                    {#if $disposableCards.length > 0}
                        <ButtonDisposal count={$disposableCards.length} on:click={disposeCards} />
                    {/if}
                </div>
            {:else}
                <ButtonChangeCard on:click={switchModes} />
            {/if}            
        {/if}

        {#if $join.state === "VOTING"}
            <div in:AnimIN out:AnimOUT class="voting-cards">
                {#each $options as option, i}
                    <Option on:click={() => pickOption(option.id)} picked={option.id === $pickedOption} card={option} char={chars[i]} />
                {/each}
            </div>
        {/if}

        {#if $join.state === "VOTE_RESULTS"}
            <div in:AnimIN out:AnimOUT class="results">
                <div class="results-info">{$position}</div>
                <ButtonReady ready={$pickedReady} on:click={() => pickReady() } />
            </div>
        {/if}

    {/if}
</section>

<style>
section {
    position: absolute;
    width: 80%;    
    text-align: center;
    margin: 0px auto; 
}
.results-info {
    margin: 2em;
}
.disposal-panel{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
}
@media screen and (max-width: 1000px) {
    .all-cards{
        margin-top: -150px;
    }
    .voting-cards{
        margin-top: -200px;
    }
    .results{
        margin-top: -200px;
    }
}
</style>

<script>
import { AnimIN, AnimOUT } from "../../code/anim.js"

import Card from "../../components/cards/Card.svelte"
import ButtonChangeCard from "../../components/buttons/ChangeCard.svelte"
import ButtonReady from "../../components/buttons/Ready.svelte"
import ButtonCancel from "../../components/buttons/Cancel.svelte"
import ButtonDisposal from "../../components/buttons/Disposal.svelte"
import Option from "./parts/Option.svelte"

import { writable } from "svelte/store"
import { onDestroy } from "svelte"
import { join, changeJoinState } from "../../stores/join"
import { host } from "../../stores/host"
import { cards } from "../../stores/cards"
import { profile } from "../../stores/profile"
import { pick, options, pickedOption, pickedReady, position, points } from "../../stores/index"

const chars = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'X', 'V', 'Z']

export let socket

let allCards = []
cards.subscribe( _allCards => allCards = _allCards )

let picked = null

const pickSub = pick.subscribe( pickedCard => picked = pickedCard)
onDestroy(pickSub)

const joinSub = join.subscribe( room => {
    if (room.state === "QUESTIONING" && picked) {
        changeJoinState("QUESTIONING_PICKED")
    }
} )
onDestroy(joinSub)

const disposableCards = writable(false)
const pickCard = id => {
    if (!$disposableCards) {
        changeJoinState("QUESTIONING_PICKED")
        pick.set({id})
        socket.emit('pickCard', id)
    } else {
        const cardIndex = $disposableCards.findIndex(cardId => cardId === id)
        if (cardIndex !== -1) {
            $disposableCards.splice(cardIndex, 1)
        } else {
            $disposableCards.push(id)
        }
    }
    disposableCards.set($disposableCards)
}

const pickOption = id => {
    if($pickedOption === id) return;
    pickedOption.set(id)
    socket.emit('pickOption', id)
    picked = null
}

const pickReady = () => {
    socket.emit('ready')
}

const disposeCards = async() => {
    const cost = $disposableCards.length * 20
    if ($points < cost) return; // not enough points
    points.set($points - cost)

    const newCards = $cards.filter( card => !$disposableCards.includes(card.id) )
    cards.set(newCards)
    const disposabledCards = $disposableCards.map(card => card)
    disposableCards.set(false)
    
    // TODO: Sit mani nost, nihuja nesaprotu, kāpēc nepieciešams te ielikt timeoutu. Bez timeouta jaunās kārtis kas atnāk, domā, ka
    // joprojām ir disposable mode un rādās zilā krāsā. Un timeout tāpēc jābūt pat 500 ms lielam. Neko nesaprotu!
    setTimeout(() => {
        socket.emit("disposeCards", disposabledCards)
    }, 500)
}

const goBack = () => socket.emit('state', 'IDLE')

const switchModes = () => {    
    disposableCards.set( $disposableCards ? false : [] )
}
</script>